import React, { useState } from 'react'
import OfficeImg from "../assets/office2.png"
import { api } from '../app/Api/ApiSlice'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

const SuggestedStoreBranchCard = ({ b }) => {
    const [isLoading,setIsLoading] = useState(false)

     const { name } = useParams()

      const handleAdd = async(id)=>{
        try {
            setIsLoading(true)
            const response = await api.post(`/stores/${name}/manage/branches/requests/sent`,{branch:id})

            console.log("add_store_branch:",response)
            if(response){
                setIsLoading(false)
                toast.success("branch requested to join")
            }
        } catch (error) {
            setIsLoading(false)
            toast.error(error.response.data.message)
        }finally{
            setIsLoading(false)
        }
    }
    return (
        <div className="branch-info">
            <img src={b.logo ? b.logo.url : OfficeImg} alt="" />
            <div className="branch-desc">
                <h3>{b.name}</h3>
                <p>
                    {b.description
                        ? b.description.length > 50
                            ? `${b.description.substring(0, 50)}...`
                            : b.description
                        : "No description available"}
                </p>

                <button className="branch-action-card-btn" onClick={() => handleAdd(b._id)}>{!isLoading?"Add branch":"..."}</button>
            </div>
        </div>
    )
}

export default SuggestedStoreBranchCard